export default "<xo-tile title=\"User Component\">\n</xo-tile>\n";